import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconSuperWifiProps } from './IconSuperWifi.types'
import * as Styled from './styles/IconSuperWifi.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSuperWifi: FC<IconSuperWifiProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSuperWifiProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconSuperWifiProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M49.44 43.11 20.25 74a7.79 7.79 0 0 0 0 11l70.2 68.73a7.8 7.8 0 0 0 11 .08l.08-.08L171.75 85a7.79 7.79 0 0 0 0-11l-29.64-31.35a7.68 7.68 0 0 0-5.54-2.36H55.43a7.68 7.68 0 0 0-5.54 2.36l-.45.46'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
        <path d='M44.52 81.76a72.77 72.77 0 0 1 102.91-.05v.05' fill='none' vectorEffect='non-scaling-stroke' />
        <path d='M59.23 97.34a52 52 0 0 1 73.53 0m-58.13 15.71a30.23 30.23 0 0 1 42.74 0' fill='none' vectorEffect='non-scaling-stroke' />
        <circle cx='96' cy='132.38' fill='none' r='2.71' vectorEffect='non-scaling-stroke' />
        <circle cx='96' cy='132.38' fill='none' r='1.69' vectorEffect='non-scaling-stroke' />
        <circle cx='96' cy='132.38' fill='none' r='.68' vectorEffect='non-scaling-stroke' />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconSuperWifi
